import {useState, useEffect, useMemo} from 'react'
import C from "helpers/HelpConstants";
import {HelpAbility} from "helpers/HelpAbility";
import Item from 'components/Processlog/Item';
import SpinnerBootrap from 'components/SpinnerBootrap';

function Table({datos, datosF, titulo, setModalMessageShow, isEmpty, setArrayProcesslog}){
 let myAbilities = HelpAbility();
 let D = useMemo(() => {
   return isEmpty ? [] : datosF.length ? datosF : datos;
 }, [datos, datosF, isEmpty])
 const [cantidadRegistros, setCantidadRegistros] = useState("5");
 const [datosFiltrados, setDatosFiltrados] = useState([])
 const [loading, setLoading] = useState(false);

 const cantidadRegistrosHandle = (e) => {
  setCantidadRegistros(e.target.value)
 };

 useEffect(() => {
  setLoading(true);
  setDatosFiltrados(D.slice(0, parseInt(cantidadRegistros)))
  setTimeout(() => {
    setLoading(false);
  }, 800) 
 }, [cantidadRegistros, D])

 return (
  <div className="my-5">
   <div className="row mb-2">
    <div className="col d-flex align-items-end">
     <h4>{titulo}</h4>
    </div>
    <div className="col d-flex justify-content-end"> 
     <div className="row d-flex align-items-center">
     <div className="col" style={{"textAlign": "right"}}>
      <label className="mr-sm-2 form-label" htmlFor="cantidadRegistros">Top</label>
     </div>
     <div className="col">
      <select className="form-select mr-sm-2" id="cantidadRegistros" value={cantidadRegistros} onChange={cantidadRegistrosHandle}>
        <option value="" disabled>Top</option>
        <option value="5">5</option>
        <option value="10">10</option>
        <option value="25">25</option>
        <option value="50">50</option>
        <option value="100">100</option>
      </select>
     </div>
     </div> 
    </div>
   </div>
   <div className="table-responsive rounded-3" style={{border: '1px solid black'}}>
    <table className="table">
     <thead>
      <tr>
          <th scope="col" className="text-center">#</th>
          <th scope="col" className="text-center">Fecha del Proceso</th>
          <th scope="col" className="text-center">Nombre del Comando</th>
          <th scope="col" className="text-center">Identificador</th>
          <th scope="col" className="text-center">N° de Repeticiones</th>

          {myAbilities.hasAny([C.A.DEPARTAMENT.UPDATE, C.A.DEPARTAMENT.DELETE]) && 
          <th scope="col" className="text-center">Mensaje</th>}
      </tr>
     </thead>
     <tbody>
     {
        datosFiltrados.length ? 
        !loading
          ?
          datosFiltrados.map((error, i) => <Item 
              key={i}  
              i={i} 
              error={error} 
              setModalMessageShow={setModalMessageShow}
              setArrayProcesslog={setArrayProcesslog}
          />) 
          :
          <SpinnerBootrap/>
        
        :
        <tr>
            <td colSpan="5">Sin datos</td>
        </tr>
     }
     </tbody>
    </table>
   </div>
 </div>
 )
}

export default Table
